import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="header">
      <Link to="/" className="logo">
        <span className="logo-icon">✈</span>
        <span className="logo-text">AIRCRAFT DEX</span>
      </Link>
    </header>
  );
}

export default Header;
